import { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase-config';
import { buscarWebs } from './websPublicadas.data';

/* Webs (sin 360) de una cámara. Fuente: Firestore `paginasWeb/{feedID}` (o `{identifier}` si no tiene feed) ({ webs: [{ titulo, url, tipo, actualizada }] }),
   que se actualiza con D:/GSG/r360/guardarweb.py sin volver a publicar la plataforma. Mientras carga, o si no hay
   documento, usa websPublicadas.data.js. Un documento con `webs: []` = la cámara no tiene web (se respeta). */
export default function useWebs(feedID, identifier) {
  const [webs, setWebs] = useState(() => buscarWebs(feedID));
  useEffect(() => {
    let vivo = true;
    setWebs(buscarWebs(feedID));
    // Por feedID; si la cámara todavía no tiene feed (cliente recién dado de alta), por su identifier (P_xxx).
    const claves = [feedID, identifier].filter(Boolean).map(String);
    if (!claves.length) return undefined;
    (async () => {
      for (const c of claves) {
        const d = await getDoc(doc(db, 'paginasWeb', c)).catch(() => null);
        if (d && d.exists() && Array.isArray(d.data().webs)) { if (vivo) setWebs(d.data().webs.length ? d.data().webs : null); return; }
      }
    })();
    return () => { vivo = false; };
  }, [feedID, identifier]);
  return webs;
}
